import styled from 'styled-components';
export const Trigger = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background-color: #fff;
  padding-left: 0.5rem;

  ${({ errors, name, outlined, theme, hasInitialSelectionChanged, opened }) => {
    const borderColor = (errors === null || errors === void 0 ? void 0 : errors[name])
        ? theme.colors.error
        : hasInitialSelectionChanged || opened
            ? theme.colors.black
            : theme.colors.grey10;
    const textColor = hasInitialSelectionChanged
        ? theme.colors.black
        : `rgba(${theme.colors.transparentBlack}, 0.36)`;
    return `
      ${!outlined ? 'border: none;' : ''}
      border${!outlined ? '-bottom' : ''}: 1px solid ${borderColor};
      color: ${textColor}
    `;
}};

  :hover {
    cursor: pointer;

    background-color: ${({ theme, outlined }) => outlined ? theme.colors.offWhite : `rgba(${theme.colors.transparentBlack}, 0.04)`};

    ${({ outlined, theme, errors, opened }) => {
    if ((errors && Object.keys(errors).length > 0) || opened) {
        return '';
    }
    return `
        ${!outlined ? 'border: none;' : ''}
        border${!outlined ? '-bottom' : ''}: 1px solid ${theme.colors.grey14};
      `;
}}
  }

  :active {
    transition: background-color,
      border-color 0.3s ${({ opened }) => (opened ? 'ease-in' : 'ease-out')};
    background-color: ${({ theme, outlined }) => outlined ? theme.colors.grey05 : `rgba(${theme.colors.transparentBlack}, 0.06)`};
    ${({ outlined, theme, errors }) => {
    if (errors && Object.keys(errors).length > 0) {
        return '';
    }
    return `
        ${!outlined ? 'border: none;' : ''}
        border${!outlined ? '-bottom' : ''}: 1px solid ${theme.colors.black};
        `;
}}
  }

  &.disabled,
  &.disabled:active,
  &.disabled:hover {
    cursor: initial;
    background-color: ${({ readOnly, theme, outlined }) => {
    if (!outlined)
        return theme.colors.white;
    if (readOnly)
        return theme.colors.grey04;
    return theme.colors.grey03;
}};
    ${({ outlined, theme, readOnly }) => `${!outlined ? 'border: none;' : ''}border${!outlined ? '-bottom' : ''}: 1px solid ${!outlined
    ? readOnly
        ? theme.colors.grey10
        : `rgba(${theme.colors.transparentBlack},0.2)`
    : `rgba(${theme.colors.transparentBlack},0)`}`};
    color: ${({ theme, readOnly }) => readOnly ? theme.colors.black : `rgba(${theme.colors.transparentBlack}, 0.26)`};
  }

  div {
    width: calc(100% - 2.5rem);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
